import { Injectable } from '@angular/core';


@Injectable()
export class ChineseChangeValueService {
     public sharedbuttonvalue:boolean=false;
  constructor() { }
  setSharedbuttonvalue()
  {
    this.sharedbuttonvalue=true;

  }
  EnglishToChineseText1:Record<string,string>= //function for dictionary of english to chinese word
  {
    'Search Package Instruction':'搜索包说明',
    'Status':'地位',
    'Send PI to system after save':'保存后将PI发送到系统',
    'Select Type':'选择类型',
    'Instruction name':'指令名称',
    'Start date':'开始日期',
    'Created date':'创建日期',
    'Updated Issuer':'更新的颁发者',
    'Issued By':'发行人',
    'Name':'名字',
    'Department':'部门',
    'Updated Approver':'更新的审批者',
    'Approver By':'审批者',
    'Part':'部分',
    'Partno':'帕特诺',
    'Consuming area':'消费面积',
    'Units':'单位',
    'Unit-Supplier-Part Relations':'单位-供应商-零件关系',
    'Supplier Number':'供应商编号',
    'Images':'图像',
    'Add Images':'添加图片',
    'Remove':'删除',
    'Packaging Materials':'包装材料',
    'Level':'水平',
    'Common material':'常用材料',
    'Edit':'编辑',
    'Weigth and Deviation':'魏格斯和偏差',
    'Packing Weight':'包装重量',
    'Gross Weight':'毛重',
    'Length':'长度',
    'Width':'宽度',
    'Height':'高度',
    'Total Part Weight (Single Part)':'总部件重量（单件）',
    'Deviation from standard measures':'偏离标准措施',
    'Weight':'重量',
    'Other Information':'其他信息',
    'Send for approval':'发送以供审批',
    'Activate':'激活',
    'The packaging instruction will be sent to the following supplier(s)':'包装说明将发送给以下供应商',
    'Dont send, activate now':'不要发送，立即激活',
    'Add comment/remarks to supplier':'向供应商添加评论/备注',
    'Cancel':'取消',
    'Image Search':'图片搜索',
    'Add':'加',
    'Close':'关闭',
  'Remove Image From Instruction':'从指令中删除图像',
  'Packaging instruction history':'包装说明历史',
  'No history for instruction':'没有教学记录',
  'available':'可用',
  'Action date':'行动日期',
  'Status from too':'状态从太',
  'User':'用户',
  'Supplier':'供应商',
  'Supplier Approver/Rejector':'供应商审批人/拒绝者',
  'Message':'消息',
  'Conflict':'冲突',
  'There is a conflict with':'與',
  'unit':'单位',
  'Continuing will scrap the other instruction and make your current instruction the new sending to system one':'繼續將廢棄其他指令，並使您當前的指令成為發送到系統一的新指令',
  'Do you wish to make your current instruction the new sending instruction and uncheck':'您是否希望將當前指令設為新的發送指令並取消選取中',
   'on the other instruction':'在另一個指令上',
   'You cannot save two sending instructions for different suppliers and same PRU when they have different packaging code or quantity':'您不能為不同的供應商保存兩個發送指並且相同的PRU當它們具有不同的包裝代碼或數量時',
   'Conflicting Instruction':'指令衝突',
   'OK Scrap':'好的廢料',
   'Yes Uncheck':'是取消選取', 
   //part-search page
   
    'Search Part':'搜索部分',
    'Search text (part number or description) - min 2 chars. First 25 records will be shown as you type':'搜索文字（ 部件號或描述） -  最少 2  個字元。前 25  條記錄將在您鍵入時顯示',
    'Search in description (note! slow)':'在描述中搜尋（注意！慢)',
    //'Partno':'帕特诺',
    //'Status':'地位',
    'Cons.areas':'缺點領域',
    'Description':'描述',
    'Missing':'失蹤',
    'Ok':'還行',
    //'Add':'加',
    //'Cancel':'取消',
    
    //packaging material part in PI Page
    'Edit level':'編輯級別',
    'Add code':'添加代碼',
    'Add additional material':'添加其他材料',
    'No code or addtional material exist for this level':'此級別不存在代碼或其他材料',
            'Click Add code and/or Add additional material button to add code/material':'按下添加代碼和/或添加其他材料按鈕以添加代碼/材料',
            'Loading packaging codes':'載入包裝代碼',
            'Part qty in unit':'零件數量單位',
            'Part qty of unit':'派特奇本烏尼特',
            'Please enter a number bigger than zero':'請輸入大於零的數位',
            'Packaging Material':'包裝材料',
            'Quantity':'數量',
           // 'Description':'描述',
            'Please make sure that Packaging code longer than 2 is only selected for SL-Internal':'請確保僅為 SL-內部選擇長度大於 2 的打包代碼',
            'You have selected a code with sub level contraints, please select packaging code for level 2':'您選擇了帶有子級別限制的代碼，請選擇級別 2 的包裝代碼',
            'When you press the update button level 2 packaging code will be replaced and level 3 packaging code (if any) will be deleted':'當您按下更新按鈕時，2級包裝代碼將被替換，並且 3 級包裝代碼（如果有）將被刪除',
            'Packaging code':'包裝代碼',
            'Qty Of Unit':'凱蒂本烏尼特',
            'Additional material':'阿迪蒂奧納爾馬特里亞爾',
            'Update instruction':'厄普達特英斯特勒克蒂翁',
    //fordislpayofPackaging material on UI
    'Click edit button to add code/material':'单击编辑按钮以添加代码/材料',
    'Free text':'自由文本',
     'To lvl':'至 lvl',
     'Loading additional materials':'装载其他材料',
     'Sum of Additional Material':'附加材料的总和',
     'Additional Material':'附加材料',
     'Level remarks':'级别备注',
     //Dialog of Search Code
     'Search code':'搜索代码',
     'Start typing to search packaging code - min 2 chars. Top 25 will be listed as you type.':'开始输入以搜索包装代码 - 最少 2 个字符。前 25 名将在您键入时列出.',
     'Code name':'代号',
     'Note for':'注意事项',
     'Sequence Instruction':'序列指令',
     'packaging code 95,99 & 568xxx are not populated':'未填充包装代码 95，99 和 568xx',
     //Dialog of Search Material
     'Search material':'搜索材料',
     'Start typing to search packaging material - min 2 chars. Top 25 will be listed as you type':'开始打字以搜索包装材料 - 最少 2 个字符。前 25 名将在您键入时列出',
     'MH No':'MH 否',
     'Packaging type':'包装类型',
     'Search text (part number, CU number or description) - min 2 chars. First 25 records will be shown as you type.':'搜索文本（零件编号、CU 编号或说明）- 至少 2 个字符。您键入时将显示前 25 条记录。',
     'Search in description "note! slow"':'在描述中搜索“注意！慢”',
     'Select':'选择',
     'Part no/CU no':'零件号/CU 号',
     'Type':'类型',
     'Search for Images':'搜索图片',
     'Upload new Image':'上传新图片',
     'Add existing label to search':'添加现有标签进行搜索',
     'Type label to search or select from list to the left: (minimum 6 characters per label)':'输入标签进行搜索或从左侧列表中选择：（每个标签至少 6 个字符',
     'Search':'搜索',
     'Search Distribution Unit':'搜索分配单位',
     'Distribution Status':'分布状况',
     'Issue Date':'签发日期',
     'MH-/568/PSCS number':'MH-/568/PSCS 号码',
     'Alternative ID':'备用 ID',
     'Suitable For':'适合于',
     'Region':'地区',
     'Stackable':'可堆叠',
     'Washable':'可洗的',
     'Breakdown':'分解',
     'Packaging Pool':'包装池',
     'Material Classification':'材质分类',
     'Storage Condition':'储存情况',
     'Dispatcher':'调度员',
     'Receiver':'接收者',
     'Main store':'总店',
     'Washing':'洗涤',
     'Consuming Area':'消费面积',
     'Color':'颜色',
     'Remarks':'评论',
     'Add Image':'添加图片',
     'Content':'内容',
     'Material':'材料',
     'Please enter a number greater than zero':'请输入一个大于零的数字',
     'Add Code':'添加代码',
     'Outer Unit':'外部单元',
     'Inner Unit':'内部单元',
     'Remarks Content':'备注内容',
     'Distribution data':'分布数据',
     'Unit net weight':'单位净重',
     'Unit gross weight':'单位毛重',
     'Unit length':'单位长度',
     'Unit width':'单位宽度',
     'Unit height':'单位高度',
     'Unit volume':'单位体积',
     'Loading attribute lists ...':'正在加载属性列表...',
     'Main':'主要的',
     'Preliminary':'初步的',
     'Active':'积极的',
     'Phasing Out':'逐步淘汰',
     'Scrapped':'报废',
     'Version':'版本',
     'MH-/568/PSCS No':'MH-/568/PSCS 否',
     'Outer':'外',
     'Inner':'内',
     'Estimated kg CO2':'估计二氧化碳千克数',
     'Colour':'颜色',
     'Suitable for':'适合于',
     'Consuming areas':'消费领域',
     'Packaging supplier':'包装供应商',
     'Responsible Name':'负责人姓名',
     'Initial Creator Name':'初始创建者名称',
     'Select Material':'选择材料',
     'kg CO2 / kg material':'千克二氧化碳/千克材料',
     'Packaging owner':'包装业主',
     'Washing indicator':'洗涤指示器',
     'Breakdown indicator':'故障指示器',
     'Pool indicator':'矿池指示器',
     'Returnable':'可退货',
     'Material classification':'材质分类',
     'Storage condition':'储存情况',
     'Replacing':'更换',
     'Replaced by':'取而代之',
     'Price':'价格',
     //Packaging Code      
     'Packaging Code':'包装代码',
     'Composition':'组成',
     'Add Material':'添加材料',
     'Constraints':'约束',
     'Add Constraint':'添加约束',
     'Remove Image From Packaging Code':'从包装代码中删除图像',
     'Pools and Washing':'泳池和洗衣房',
     'Washing supplier':'洗涤用品供应商',
     'Only for closed loop':'仅适用于闭环',
     'Remove Image From Material':'从材质中删除图像',
     'Select Supplier(s)':'选择供应商',
     'Supplier Name':'供应商名称',
     'Search Sequence Instruction':'搜索包说明',
     'Description of Instruction': '指令说明',
      'Part/CU':'零件/CU',
      'Part(s)/CU(s)':'零件/CU',
      'Total Part(s) Weight(g)':'零件总重量(g)',
      'Cannot save, as conflict exists. Please manually resolve the conflict to save the instruction.':'无法保存，因为存在冲突。请手动解决冲突以保存指令',
      'Instruction':'操作说明',
      'Part Number':'零件号',
      'Classification':'分类',
      'Dispatchers/Receiver':'调度员/接收员',
      'Packaging types':'包装类型',
      'Material Exclusion':'材料排除',
      'Materials':'材料',
      'Supplier information':'供应商信息',
      'Material MH No.':'材料 MH 号',
      'Is Active':'活跃',
      'Select supplier':'选择供应商',
      'Please update your contact information.':'请更新您的联系信息。',
      'Confirm':'确认',
      'Press the "Confirm" button to verify validity of current contact information.':'按“确认”按钮验证当前联系信息的有效性。）',
      'Supplier Information':'供应商信息',
      'Contact name':'联系人姓名',
      'Email':'电子邮件',
      'Phone':'电话',
      'Valid for':'有效期为',
      'Both (Scania Production Europe & Spare Parts Centre)':'两者（斯堪尼亚欧洲生产中心和备件中心）',
      'Scania Production Europe':'斯堪尼亚欧洲生产公司',
      'Spare Parts Centre':'备件中心',
      'Recieve email for PI activation':'接收 PI 激活电子邮件',
      'Recieve email for PM or DU changes':'接收 PM 或 DU 变更的电子邮件',
      'Add new contact':'添加新联系人',
      'Extended Supplier Information':'扩展供应商信息',
      'Select part':'选择部分',
      'Selected main part':'选定的主要部分',
      'Consists of part':'由部分组成',
      'Text':'文本',
      'For a user to be able to see instructions that belongs to his/hers pru in the dashboard, a pru<br> record in packit user settings table must exist. In this screen you can add, update and remove <br>user settings. You can also specify wether a user can send instructions to suppliers and<br>activate instructions. The settings only applies to the roles packaging enginer and packit admins':'为了使用户能够在仪表板中查看属于他/她的 pru 的说明，packit 用户设置表中必须存在 pru<br> 记录。在此屏幕中，您可以添加、更新和删除用户设置。您还可以指定用户是否可以向供应商发送指令并<br>激活指令。这些设置仅适用于包装工程师和 Packit 管理员角色',
      'Please note that the user must order the role access in OrderIT or AA separately':'请注意，用户必须在 OrderIT 或 AA 中单独订购角色访问权限',
      'User id':'用户身份',
      'Find user':'查找用户',
      'Pru':'普鲁',
      'Can send to supplier and activate':'可以发送给供应商并激活',
      'Save':'节省',
      'Existing users for PRU':'现有用户为 普鲁',
      'User Id':'用户身份',
      'User name':'用户名',
      'Is approver':'是批准者',
      'Edit user setting':'编辑用户设置',
      'Remove user setting':'删除用户设置',
      'Select Module':'选择模块',
      'Records':'记录',
      'All Records':'所有记录',
      'Specific Records':'具体记录',
      'PI Name':'PI 名称',
      'Issuer User Id':'发行人用户 ID',
      'Approver User Id':'审批者用户 ID',
      'Initial Creator User Id':'初始创建者用户 ID',
      'Responsible User Id':'负责的用户 ID',
      'SI Name':'国际单位名称',
      'Enter Old Global ID':'输入旧全局 ID',
      'Issuer User':'发行人用户',
      'Approver User':'审批者用户',
      'Responsible User':'负责任的用户',
      'Enter New Global ID':'输入新的全局 ID',
      'Submit':'提交'
      
  }
  getsharedbuttonvalue()
  {
    return this.sharedbuttonvalue;
  }
  
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/chinese-change-value.service.ts